export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyASG7KxDO2z5AH9r0jlUmwiw68Ap8kG20c',
    authDomain: 'ngx-auth-firebaseui.firebaseapp.com',
    databaseURL: 'https://ngx-auth-firebaseui.firebaseio.com',
    projectId: 'ngx-auth-firebaseui',
    storageBucket: 'ngx-auth-firebaseui.appspot.com',
    messagingSenderId: '520699629648',
    appId: '1:520699629648:web:20aed11397e69d5f6c8155',
    measurementId: 'G-18CVQPFZG1'
  }
};
